import { EQStateType, ReturnViewMode } from ".";

export type EQMenuStatusBadgeType = {
	label: string;
	backgroundColor: string;
	ticketNumber?: string;
	time?: string;
	queueCount?: number;
};

type BuildReturnMenuStatusBadgeParams = {
	queueCount: number;
	ticketNumber?: string;
	pauseElapsed?: string;
	pauseTotalElapsed?: string;
	callElapsed?: string;
	serviceElapsed?: string;
};

/** Короткая подпись и данные бейджа пункта меню re:turn (развёрнутое боковое меню) */
export const buildReturnMenuStatusBadge = (
	viewMode: ReturnViewMode,
	returnState: EQStateType,
	params: BuildReturnMenuStatusBadgeParams
): EQMenuStatusBadgeType | undefined => {
	const backgroundColor = (returnState.borderTopColor || returnState.color || "#748398").trim();

	switch ( viewMode ) {
		case "inactive":
			return {
				label: returnState.text,
				backgroundColor
			};
		case "free":
			return {
				label: "Пригласите",
				backgroundColor,
				queueCount: params.queueCount
			};
		case "confirming":
			return {
				label: "Подтвердите",
				backgroundColor,
				ticketNumber: params.ticketNumber
			};
		case "called":
			return {
				label: "Вызван",
				backgroundColor,
				ticketNumber: params.ticketNumber,
				time: params.callElapsed
			};
		case "working":
			return {
				label: "Работа",
				backgroundColor,
				time: params.serviceElapsed
			};
		case "pause":
			return {
				label: "Перерыв",
				backgroundColor,
				time: params.pauseTotalElapsed ?? params.pauseElapsed
			};
		default:
			return undefined;
	}
};

/** Текст подсказки при свёрнутом меню */
export const formatReturnMenuHint = (badge: EQMenuStatusBadgeType): string => {
	const parts = [ badge.label ];
	if ( badge.ticketNumber ) {
		parts.push( badge.ticketNumber );
	}
	if ( badge.queueCount != null ) {
		parts.push( String( badge.queueCount ) );
	}
	if ( badge.time ) {
		parts.push( badge.time );
	}
	return parts.join( " " );
};
